import { gql } from "@apollo/client";

export const GET_CRYPTO_PRICING = gql`
  query GetCryptoPricing($input: GetCryptoPricingEstimateInput!) {
    getCryptoPricingEstimate(input: $input) {
      success
      data {
        cryptoAmount
        symbol
        usdPrice
      }
      error {
        message
      }
    }
  }
`;

export const MAKE_CRYPTO_DEPOSIT = gql`
  mutation MakeCryptoDeposit($input: MakeCryptoDepositInput!) {
    makeCryptoDeposit(input: $input) {
      success
      data {
        depositId
      }
      message
      error {
        message
      }
    }
  }
`;

export const GET_DEPOSIT_HISTORY = gql`
  query GetDepositHistory($userId: uuid!, $limit: Int = 20) {
    crypto_deposits(
      where: { user_id: { _eq: $userId }, status: { _in: ["confirmed", "pending"] } }
      order_by: { created_at: desc }
      limit: $limit
    ) {
      id
      crypto_type
      crypto_amount
      usd_amount
      exchange_rate
      network
      status
      wallet_address
      created_at
      confirmed_at
    }
  }
`;

export const GET_USER_WALLETS = gql`
  query GetUserWallets($input: GetUserWalletsInput!) {
    getUserWallets(input: $input) {
      success
      wallets {
        chain
        address
      }
      error
    }
  }
`;
